import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgActivityCreatedGroup = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M16.875 13.5H14.625V11.25H13.5V13.5H11.25V14.625H13.5V16.875H14.625V14.625H16.875V13.5Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M8.6625 16.875L2.8125 13.3875C2.475 13.1625 2.25 12.825 2.25 12.4313V5.56875C2.25 5.175 2.475 4.78125 2.8125 4.6125L8.4375 1.29375C8.60625 1.18125 8.775 1.125 9 1.125C9.225 1.125 9.39375 1.18125 9.5625 1.29375L15.1875 4.6125C15.525 4.8375 15.75 5.175 15.75 5.56875V9H14.625V5.56875L9 2.25L3.375 5.56875V12.4313L9.28125 15.9187L8.6625 16.875Z",
		fill: "currentColor"
	})]
});
export default SvgActivityCreatedGroup;
